import type { ReactNode } from "react";

import type { IToast } from "app/components/React/Toast/types";
import type { ThunkDispatchCommon } from "single-spa/store/types";

export const SHOW_TOAST = "SHOW_TOAST" as const;
export const HIDE_TOAST = "HIDE_TOAST" as const;
export const HIDE_TOASTS_BY_TAG = "HIDE_TOASTS_BY_TAG" as const;

export interface ToastAction {
    type: typeof SHOW_TOAST | typeof HIDE_TOAST;
    toast: IToast;
}

export interface HideToastsByTagAction {
    type: typeof HIDE_TOASTS_BY_TAG;
    tag: string;
}

export const showToast = (
    children: ReactNode,
    className: string,
    timestamp?: number,
    secondaryItems?: ReactNode[],
    tag?: string,
): ToastAction => ({
    type: SHOW_TOAST,
    toast: {
        timestamp: timestamp || Date.now(),
        children,
        className,
        secondaryItems,
        tag,
    },
});

export const hideToast = (toast: IToast): ToastAction => ({
    type: HIDE_TOAST,
    toast,
});

export const hideToastsByTag = (tag: string): HideToastsByTagAction => ({
    type: HIDE_TOASTS_BY_TAG,
    tag,
});

const makeShowToast =
    (className: string, defaultHideTimeout: number) =>
    (
        children?: ReactNode,
        timestamp?: number,
        hideTimeout = defaultHideTimeout,
        secondaryItems?: ReactNode[],
        tag?: string,
    ) =>
    (dispatch: ThunkDispatchCommon): ToastAction => {
        const toastAction = dispatch(showToast(children, className, timestamp, secondaryItems, tag));
        if (hideTimeout > 0) {
            setTimeout(() => dispatch(hideToast(toastAction.toast)), hideTimeout);
        }
        return toastAction;
    };

export const showSuccessToast = makeShowToast("success", 6000);

export const showErrorToast = makeShowToast("error", 6000);

export const showInfoToast = makeShowToast("info", 6000);
